var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    id: "svg4",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.3864 25.6136H1V64H39.3864V25.6136Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path1",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2279 12.7727H13.8416V51.1591H52.2279V12.7727Z",
    fill: "white",
    stroke: "#BDCAD1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    id: "path2",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.0006 0H26.6143V38.3864H65.0006V0Z",
    fill: "#845EC2",
    id: "path3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1848 24.6555C54.1848 26.8438 52.4655 28.5631 50.2772 28.5631C48.0889 28.5631 46.3695 26.8438 46.3695 24.6555C46.3695 24.2647 46.4477 23.9521 46.5258 23.6395L42.4619 21.6075C41.1333 23.3269 38.7105 23.6395 36.9911 22.3109C35.2718 20.9823 34.9592 18.5595 36.2878 16.8401C37.6164 15.1208 40.0391 14.8082 41.7585 16.1368C41.9929 16.2931 42.2274 16.5275 42.4619 16.8401L46.5258 14.8082C45.9788 12.698 47.2292 10.5879 49.2612 10.0408C51.3713 9.49375 53.4815 10.7442 54.0285 12.7762C54.5756 14.8082 53.3252 16.9965 51.2932 17.5435C49.8083 17.9343 48.167 17.3872 47.2292 16.2149L43.1652 18.2469C43.3215 18.8721 43.3215 19.5755 43.1652 20.2789L47.2292 22.3109C48.5578 20.5915 50.9806 20.2789 52.6999 21.6075C53.6378 22.3109 54.1848 23.4832 54.1848 24.6555Z",
    fill: "white",
    id: "path4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7e0476fe1ba100aa6ddd8e4a96fca8c4.svg";
export { ForwardRef as ReactComponent };